// eslint-disable-next-line import/no-anonymous-default-export
export default {
    semiForcedLater: {
        eventCategory: 'updateApp',
        eventAction: 'semi_forced_later',
        event: 'semi_forced_later'
    },
    loginPage: {
        eventCategory: 'login',
        eventAction: 'login_page_load',
        event: 'login_page',
    },
    enterMobileNumber: {
        eventCategory: 'login',
        eventAction: 'enter_mobile_number_enter',
        event: 'enter_mobile_number'
    },
    getOtp: {
        eventCategory: 'login',
        eventAction: 'get_otp_click',
        event: 'get_otp'
    },
    resentOtp: {
        eventCategory: 'login',
        eventAction: 'resend_click',
        event: 'resend'
    },
    verifyOtp: {
        eventCategory: 'login',
        eventAction: 'verify_otp_click',
        event: 'verify_otp'
    },
    viewItemList: {
        eventCategory: 'explore',
        eventAction: 'view_item_list_',
        event: 'view_item_list'
    },
    inspectionReportView: {
        eventCategory: 'pdp',
        eventAction: 'insp_rep_view_',
        event: 'insp_rep_view_'
    },
    placeBid: {
        eventCategory: 'pdp',
        eventAction: 'place_bid_click',
        event: 'place_bid'
    },
    submitBid: {
        eventCategory: 'place_bid',
        eventAction: 'submit_bid_click',
        event: 'submit_bid'
    },
    searchEnter: {
        eventCategory: 'explore',
        eventAction: 'search_enter',
        event: 'search'
    },
    bellClick: {
        eventCategory: 'explore',
        eventAction: 'bell_click',
        event: 'bell'
    },
    notificationClick: {
        eventCategory: 'explore',
        eventAction: 'notification_click',
        event: 'notification'
    },
    refreshClick: {
        eventCategory: 'explore',
        eventAction: 'refresh_click',
        event: 'refresh'
    },
    imageHorizontalScrollDepth: {
        eventCategory: 'explore',
        eventAction: 'image_horizontal_scroll_depth',
        event: 'image'
    },
    exploreClick: {
        eventCategory: 'explore',
        eventAction: 'explore_click',
        event: 'explore'
    },
    myBidsClick: {
        eventCategory: 'explore',
        eventAction: 'my_bids_click',
        event: 'my_bids'
    },
    myWinsClick: {
        eventCategory: 'explore',
        eventAction: 'my_wins_click',
        event: 'my_wins'
    },
    accountClick: {
        eventCategory: 'explore',
        eventAction: 'account_click',
        event: 'account'
    },
    pdpImageHorizontalScrollDepth: {
        eventCategory: 'pdp',
        eventAction: 'image_horizontal_scroll_depth',
        event: 'image'
    },
    pdpImageClick: {
        eventCategory: 'pdp',
        eventAction: 'image_click',
        event: 'image'
    },
    thumbnailClick: {
        eventCategory: 'pdp',
        eventAction: 'thumbnail_click',
        event: 'thumbnail'
    },
    imageThumbnailClick: {
        eventCategory: 'pdp',
        eventAction: 'image_thumbnail_click',
        event: 'image_thumbnail'
    },
    raiseBid: {
        eventCategory: 'explore',
        eventAction: 'raise_bid_click',
        event: 'raise_bid'
    },
    addToWatchList: {
        eventCategory: 'explore',
        eventAction: 'add_to_watch_list_click',
        event: 'add_to_watch_list'
    },
    watchListPage: {
        eventCategory: 'watchList',
        eventAction: 'watch_list_page_visit',
        event: 'watch_list_page_visit'
    },
    watchListIconClick: {
        eventCategory: 'explore',
        eventAction: 'watch_list_icon_click',
        event: 'watch_list_icon'
    },
    auctionsFilter: {
        eventCategory: 'combineAuctions',
        eventAction: 'auctions_filter_click',
        event: 'auctions_filter'
    },
    pdpPageLoad: {
        eventCategory: 'pdp',
        eventAction: 'pdp_page_load',
        event: 'pdp_page'
    },
    accordionClick: {
        eventCategory: 'pdp',
        eventAction: 'accordion_click',
        event: 'custom_event',
    },
    myCarTabClick: {
        eventCategory: 'explore',
        eventAction: 'my_car_tab',
        event: 'custom_event',
    },
    myWinsTabClick: {
        eventCategory: 'explore',
        eventAction: 'my_wins_tab',
        event: 'custom_event',
    },
    myDealsTabClick: {
        eventCategory: 'explore',
        eventAction: 'my_deals_tab',
        event: 'custom_event',
    },
    infoIconClick: {
        eventCategory: 'explore',
        eventAction: 'info_icon_click',
        event: 'custom_event',
    },
    myOrdersClick: {
        eventCategory: 'explore',
        eventAction: 'my_orders_click',
        event: 'custom_event',
    },
    requestCallbackPageLoad: {
        eventCategory: 'login',
        eventAction: 'request_callback_page_load',
        event: 'custom_event',
    },
    requestCallbackClick: {
        eventCategory: 'login',
        eventAction: 'request_callback_click',
        event: 'custom_event',
    },
    justCheckingClick: {
        eventCategory: 'login',
        eventAction: 'just_checking_click',
        event: 'custom_event',
    }
};